module.exports = __webpack_public_path__ + "img/project4_8.jpg.45d0889f.webp";